import { ref } from "vue";

// state user login (module-level supaya dibagi semua komponen);
// diisi router guard tiap navigasi dari respon /user/user_data
const user = ref(null);

export function setUser(u) {
  user.value = u;
}

export function clearUser() {
  user.value = null;
}

export default function useAuth() {
  // hapus token + state → pemanggil yang mengarahkan ke /login
  let logout = () => {
    localStorage.removeItem(process.env.VUE_APP_TOKEN_NAME);
    clearUser();
  };

  return { user, logout };
}
